import React, { useEffect } from 'react';
import { Modal } from "../../../../../components/modal/modal.jsx";
import { FaExternalLinkAlt } from "react-icons/fa";
import ReportUtils from "../../../../../utils/report-utils.js";
import {fixMonetaryValue, readjustTimezone} from "../utils/translate.jsx";

const BASENAME = import.meta.env.BASE_URL;

const ModalDetailsContent = ({ open, setOpen, data }) => {

    useEffect(() => {
        ReportUtils.withoutContentReadjust();
    }, [data]);

    const isVehicle = data?.source === 'getSuppliesByVehicle';

    return (
        <Modal open={open} setOpen={setOpen} title={`Abastecimentos: ${data.text}`} isCloseClick={true}>
            <Modal.Body className="pt-0 !m-0 align-self-center justify-items-center">

                <div className="w-full my-2">
                    <table className="table report-table my-2">
                        <thead className="thead-background">
                            <tr className="bg-[#f6f6f6] text-left">

                                <th className="w-[14%]">Data/Hora</th>

                                {
                                    isVehicle ? (
                                        <th className="w-[17%]">Condutor</th>
                                    ) : (
                                        <th className="w-[15%]">Veículo (Prefixo - placa)</th>
                                    )
                                }

                                {
                                    isVehicle ? (
                                        <th className="w-[17%]">Posto de combustível</th>
                                    ) : (
                                        <th className="w-[15%]">Condutor</th>
                                    )
                                }

                                <th className="w-[15%]">Km ao abastecer</th>
                                <th className="w-[13%]">Combustível</th>
                                <th className="w-[13%]">Quantidade</th>
                                <th className="w-[12%]">Valor</th>
                                <th className="w-[1%] print:hidden"></th>

                            </tr>
                        </thead>

                        <tbody className="bg-white">

                            { data?.supply_details?.map((element, index) => (

                                <tr key={index}>
                                    <td className="w-[14%]">{readjustTimezone(element.date)}</td>

                                    {
                                        isVehicle ? (
                                            <td className="w-[17%]">{ReportUtils.formatText(element.conductor)}</td>
                                        ) : (
                                            <td className="w-[15%]"><a href={`${BASENAME}vehicles/form/${element.vehicle_id}`} target={"_blank"} className={'inner-link'}>{element.vehicle}</a></td>
                                        )
                                    }

                                    {
                                        isVehicle ? (
                                            <td className="w-[17%]">{element.gas_station}</td>
                                        ) : (
                                            <td className="w-[15%]">{ReportUtils.formatText(element.conductor)}</td>
                                        )
                                    }

                                    <td className="w-[15%]">{element.current_km}</td>
                                    <td className="w-[13%]">{element.fuel_type}</td>
                                    <td className="w-[13%]">{element.qty}</td>
                                    <td className="w-[12%]">{fixMonetaryValue(element.price)}</td>
                                    <td className="w-[1% print:hidden]">
                                        <FaExternalLinkAlt
                                            size={14}
                                            title={'Abastecimento'}
                                            className="details-link"
                                            onClick={() => {window.open(`${BASENAME}supplies/form/${element.supply_id}`, "_blank");
                                            }}
                                        />
                                    </td>

                                </tr>

                            ))}

                        </tbody>
                    </table>
                </div>

            </Modal.Body>
        </Modal>
    );
};

export default ModalDetailsContent;